import { FulfillmentOrderData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import {
  RedoBadge,
  RedoBadgeColor,
  RedoBadgeSize,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import AlertTriangleIcon from "@redotech/redo-web/arbiter-icon/alert-triangle.svg";
import DotIcon from "@redotech/redo-web/arbiter-icon/dot-01.svg";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";

export const AddressVerificationColumn: Column2<FulfillmentOrderData> = {
  alignment: ColumnAlignment.LEFT,
  key: "address-verification",
  title: "Address Verification",
  renderNormalCell: ({ row }: { row: FulfillmentOrderData }) => (
    <Flex pl="lg">
      {row.destinationAddress.verified ? (
        <RedoBadge
          color={RedoBadgeColor.SUCCESS}
          segmentLeading={{ type: "icon", Icon: DotIcon }}
          size={RedoBadgeSize.X_SMALL}
          text="Verified"
        />
      ) : (
        <Tooltip
          placement="bottom-start"
          title={row.destinationAddress.messages?.join(", ") ?? ""}
        >
          <div>
            <RedoBadge
              color={RedoBadgeColor.ERROR}
              segmentLeading={{ type: "icon", Icon: AlertTriangleIcon }}
              size={RedoBadgeSize.X_SMALL}
              text="Error"
            />
          </div>
        </Tooltip>
      )}
    </Flex>
  ),
  width: 160,
};
